import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import 'radar-sdk-js/dist/radar.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'react-international-phone/style.css';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
